import React from "react";

const CreateNutritionPlan = React.lazy(() => import("./CreateNutritionPlan"));
const Index = React.lazy(() => import("./index"));
const NutritionPlanDetails = React.lazy(() => import("./NutritionPlanDetails"));

export const nutritionPlanRoutes = [
	{
		path: "/admin/nutritionPlan",
		name: "Nutrition Plans",
		element: <Index />,
	},
	{
		path: "/admin/nutritionPlan/create",
		name: "Create Nutrition Plans",
		element: <CreateNutritionPlan />,
	},
	{
		path: "/admin/nutritionPlan/update/:id?",
		name: "Create Nutrition Plans",
		element: <CreateNutritionPlan />,
	},
	{
		path: "/admin/nutritionPlan/:id?",
		name: "Nutrition Plan",
		element: <NutritionPlanDetails />,
	},
];
